// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-31gi0";
var _3 = "header__text-3UJyB";
var _4 = "flight-2xI8-";
var _5 = "passenger-1ABjY";
var _6 = "notification-Qb-7M";
var _7 = "icon-1hrls";
var _8 = "text-1LoIl";
var _9 = "buttons-2Jms7";
var _a = "newSearch-EqQn7";
var _b = "continueButton-hJPZo";
export { _1 as "__esModule", _2 as "container", _3 as "header__text", _4 as "flight", _5 as "passenger", _6 as "notification", _7 as "icon", _8 as "text", _9 as "buttons", _a as "newSearch", _b as "continueButton" }
export default { "__esModule": _1, "container": _2, "header__text": _3, "flight": _4, "passenger": _5, "notification": _6, "icon": _7, "text": _8, "buttons": _9, "newSearch": _a, "continueButton": _b }
